import { lineStrings } from 'constants/strings';
import {
  ECardTypeTemplateId,
  TCardTypeAction,
  TCardTypeAdditionalInfo,
  TCardTypePrice,
  TCardTypeTag,
} from 'types/cardTypeMessage';

const s = lineStrings.management.cardTypeMessage;

export const cardTypeDefaultTag = (): TCardTypeTag => ({
  enabled: true,
  text: s.enterTagText,
  color: 'green',
});

export const cardTypeDefaultAction = (): TCardTypeAction => ({
  enabled: true,
  label: s.enterActionLabel,
  actionType: '',
  uri: '',
  text: '',
});

/** Action 2: form always visible; preview only when enabled */
export const cardTypeDefaultAction2 = (): TCardTypeAction => ({
  enabled: false,
  label: s.enterActionLabel,
  actionType: '',
  uri: '',
  text: '',
});

export const cardTypeDefaultActions = (): TCardTypeAction[] => [
  cardTypeDefaultAction(),
  cardTypeDefaultAction2(),
];

export function cardTypeDefaultImages() {
  return { a: '', b: '', c: '' };
}

/** 1つ目の価格。項目名は任意で、空のときは金額のみを表示する */
export const cardTypeDefaultPrice = (): TCardTypePrice => ({
  enabled: true,
  label: '',
  currency: '¥',
  value: '000.00',
});

/** 2つ目の価格。既定では無効で、有効化しても金額を入力するまで保存できない */
export const cardTypeDefaultPrice2 = (): TCardTypePrice => ({
  ...cardTypeDefaultPrice(),
  enabled: false,
  value: '',
});

export function cardTypeTemplateDefaults(templateId: ECardTypeTemplateId) {
  switch (templateId) {
    case ECardTypeTemplateId.People:
      return {
        name: s.enterName,
        description: { enabled: true, text: s.enterDescription },
        tags: [
          cardTypeDefaultTag(),
          cardTypeDefaultTag(),
          cardTypeDefaultTag(),
        ],
        imageCount: 1 as const,
      };
    case ECardTypeTemplateId.Pictures:
      return {
        header: '',
        tag: cardTypeDefaultTag(),
        imageCount: 1 as const,
      };
    case ECardTypeTemplateId.Places:
      return {
        header: s.enterHeader,
        tag: cardTypeDefaultTag(),
        address: { enabled: true, text: s.enterAddress },
        additionalInfo: {
          enabled: true,
          infoType: 'Hours',
          text: s.enterInfoDetails,
        } satisfies TCardTypeAdditionalInfo,
        imageCount: 3 as const,
      };
    case ECardTypeTemplateId.Products:
    default:
      return {
        header: s.enterHeader,
        tag: cardTypeDefaultTag(),
        description: { enabled: true, text: s.enterDescription },
        price: cardTypeDefaultPrice(),
        price2: cardTypeDefaultPrice2(),
        imageCount: 3 as const,
      };
  }
}
